import { render, staticRenderFns } from "./match_tag_form.vue?vue&type=template&id=1466cd55&"
import script from "./match_tag_form.vue?vue&type=script&lang=js&"
export * from "./match_tag_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports